import RelayClient from '@relay/client';
import React from 'react';
import { flushSync } from 'react-dom';
import { hydrateRoot } from 'react-dom/client';
import { registrations } from '../../.relay/registrations';
import { ConsentGate } from './ConsentGate';

const isDev = process.env.NODE_ENV === 'development';

const relay = new RelayClient(registrations, async (registration, props, container) => {
  return new Promise(async (resolve) => {
    const { default: Component } = await registration.import();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let reactComponent: any = React.createElement(Component, props as any);

    // if development wrap the component in a React.StrictMode
    if (isDev) {
      reactComponent = React.createElement(React.StrictMode, undefined, reactComponent);
    }

    flushSync(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      hydrateRoot(container, reactComponent as any);
    });

    resolve();
  });
});

const gate = new ConsentGate(() => relay.initialise());
gate.initialise();
